import type { ReportCardData } from './types';

/**
 * Report completion card (#3793). Appended at the end of a turn that built a
 * report inline, so every generated report closes with a clear "Open report"
 * CTA plus a consistent proactive follow-up nudge (instead of the response
 * trailing off into prose). The whole card is clickable → onOpen(), which
 * routes through the existing `pages.open` affordance so the user lands inside
 * the Pages chrome with the report selected.
 *
 * Mirrors NoteResultCard chrome (rc-card / rc-meta / rc-subject) with the
 * EventsResultCard footer-link affordance for the CTA.
 */
export function ReportResultCard({ data, onOpen }: { data: ReportCardData; onOpen: () => void }) {
  const { title } = data;

  return (
    <div className="rc-report">
      <button type="button" className="rc-card" onClick={onOpen}>
        <div className="rc-meta">
          <span className="rc-meta-kind">📊 REPORT</span>
        </div>

        <div className="rc-subject">{title || 'Report'}</div>
        <span className="rc-report-open">
          Open report <span aria-hidden>→</span>
        </span>
      </button>
      <div className="rc-report-followup">
        Want me to refine a section, fill in any gaps, or build a related report? Just ask.
      </div>
    </div>
  );
}
